import { useTenant } from 'lib/hooks/useTenant';

const AccomodationHead = () => {
  const { isDA } = useTenant();
  return (
    <div
      className={`${
        isDA ? 'hidden lg:flex' : 'hidden md:flex'
      } bg-[#E8E8E870] w-full py-[0.75rem] px-5 justify-between text-xs text-dark-500 font-semibold rounded-md`}
    >
      <div>ROOM TYPE</div>
      <div
        className={`flex justify-start pl-[1.35rem] ${
          isDA ? 'w-[23.5rem]' : 'w-[18.75rem]'
        }`}
      >
        <div>PRICE</div>
        <div className="ml-[6.6rem]">TRAVELLERS</div>
      </div>
    </div>
  );
};
export { AccomodationHead };
